import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { colorCodesForAvatar } from "../../../../../constants/index";
import { chracterPosition } from "../../../../../utils/index";
import { peopleEllipsisSx } from "../../peopleFormValidation";

export default function AgentDetailProfile({ agent }) {
  const letter = (agent.name || "").substring(0, 1).toUpperCase();
  const subtitle = agent.jobTitle || agent.role || agent.company || "—";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, minWidth: 0, width: "100%" }}>
      {agent.avatar ? (
        <Avatar src={agent.avatar} alt={agent.name} sx={{ width: 56, height: 56, flexShrink: 0 }} />
      ) : (
        <Avatar
          sx={{
            width: 56,
            height: 56,
            fontSize: 20,
            flexShrink: 0,
            bgcolor: colorCodesForAvatar[chracterPosition(letter)] || "#405261",
          }}
        >
          {letter}
        </Avatar>
      )}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          title={agent.name}
          sx={{
            color: "#061522",
            fontFamily: "Inter",
            fontSize: 18,
            fontWeight: 500,
            lineHeight: "34px",
            ...peopleEllipsisSx,
          }}
        >
          {agent.name}
        </Typography>
        <Typography
          title={subtitle}
          sx={{
            color: "#405261",
            fontFamily: "Inter",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "18px",
            ...peopleEllipsisSx,
          }}
        >
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
}
